import { Component, Input } from '@angular/core';
import { MenuItem } from '../../main/models/menuItem';

@Component({
  selector: 'anms-column-list',
  templateUrl: './column-list.component.html',
  styleUrls: ['./column-list.component.scss'],
  standalone: false
})
export class ColumnListComponent {
  /* #region Fields */
  @Input() public listData: MenuItem[] = [];
  selectedFilter ='Mixed';
  /* #endregion */
}
